import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { v4 } from "uuid";

import { BetCreateParams, BetsCreateResponse } from "./types";

const PROTOCOL = window.location.protocol === "https:" ? "https://" : "http://";
const HOST = window.location.host;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: `${PROTOCOL}${HOST}` }),
  endpoints: (builder) => ({
    betCreate: builder.query<BetsCreateResponse, BetCreateParams>({
      query: ({ betParams, contractor, gameId, token }) => ({
        url: "/api",
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          jsonrpc: "2.0",
          method: "bets.create",
          id: (~~(Math.random() * 1e8)).toString(16),
          params: {
            bets: betParams,
            contractor,
            game_id: gameId,
            token,
            uuid: v4(),
          },
        },
      }),
    }),
  }),
});

export const { useLazyBetCreateQuery } = api;
